export const COOKIE_CHANNEL_NAME = "channel";
export const COOKIE_IS_TEMPORARY_CHANNEL = "is_temporary_channel";
export const QUERY_CHANNEL_NAME = "channel";
export const QUERY_CHANNEL_NAME_TEMPORARY = "channel_temporary";
export const DEFAULT_CHANNEL = "website";

export const fixedChannelHosts: Record<string, string> = {
  "b2b.snapptrip.com": "b2b",
  "pwa.snapptrip.com": "jek",
  "telesale.snapptrip.com": "telesale",
  "web.snapptrip.live": "ads",
  "web.snapptrip.travel": "ads",
  "web.snapptrip.info": "ads",
  "www.snapptrip.co": "ads",
  "www.snapptrip.villas": "ads",
  "flight.snapp.ir": "snapp-ir",
  "travel.snapp.ir": "snapp-ir",
  "hotel.snapp.ir": "snapp-ir",
  "b2b-stage.snapptrip.com": "b2b",
  "pwa-stage.snapptrip.com": "jek",
  "telesale-stage.snapptrip.com": "telesale",
  "web-stage.snapptrip.live": "ads",
  "web-stage.snapptrip.travel": "ads",
  "web-stage.snapptrip.info": "ads",
  "www.stage.snapptrip.co": "ads",
  "www.stage.snapptrip.villas": "ads",
  "flight-stage.snapp.ir": "snapp-ir",
  "travel-stage.snapp.ir": "snapp-ir",
  "hotel-stage.snapp.ir": "snapp-ir",
  "pwa.st-beta.dev": "jek",
  "b2b.st-beta.dev": "b2b",
  "ir.st-beta.dev": "snapp-ir"
};
